export const AGY_CLI_VERSION = '1.1.20';
